//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* global $cramp: false */

(function () {
  const showCompleteContent = function (element, completeContent) {
    return function () {
      element.html(
        `${completeContent} <a href="#" class="truncate-show-less">less</a>`,
      );
    };
  };

  const showTruncatedContent = function (element, truncatedContent, noMore) {
    const suffix = noMore
      ? ''
      : ' ... <a href="#" class="truncate-show-more">more</a>';
    return function () {
      element.html(truncatedContent + suffix);
    };
  };

  angular.module('curalate').directive('truncatedText', [
    '$sce',
    '$parse',
    function ($sce, $parse) {
      return {
        restrict: 'C',
        transclude: false,
        link(scope, element, attrs) {
          const lines = attrs.lines;
          const height = attrs.height;
          const dynamic = attrs.dynamic !== undefined;
          const noMore = attrs.noMore !== undefined;
          const htmlMode = 'html' in attrs;
          const setContent = function (content) {
            if (htmlMode) {
              element.html($sce.getTrustedHtml(content) || '');
            } else {
              element.text(content);
            }
          };
          let crampValue;
          let truncContent;

          if (lines) {
            crampValue = parseInt(lines, 10);
          } else if (height) {
            crampValue = height;
          } else {
            crampValue = 'auto';
          }

          const crampOptions = {
            cramp: crampValue,
            truncationChar: noMore ? ' ...' : ' ... more',
          };

          const cramp = function (content) {
            // Cramp based on the text (with trunc statement) in the given element
            setContent(content);
            const result = $cramp(element[0], crampOptions);

            if (result.cramped) {
              truncContent = noMore
                ? result.cramped
                : result.cramped.slice(0, result.cramped.length - 9);
              showTruncatedContent(element, truncContent, noMore)();

              // Attach event handlers
              element.on(
                'click',
                '.truncate-show-more',
                showCompleteContent(element, content),
              );
              element.on(
                'click',
                '.truncate-show-less',
                showTruncatedContent(element, truncContent),
              );
            } else {
              // If truncation was NOT necessary, revert element to full text
              setContent(content);
            }
          };

          /* eslint no-lonely-if: off */

          // our standard trunc-text behavior presumes we are truncating static text
          // so if a truncated string is dynamic, we need to set a watcher on it
          if (htmlMode) {
            const htmlGetter = $parse(attrs.html);
            if (dynamic) {
              const htmlWatch = $parse(attrs.html, (val) =>
                // Unwrap the value to compare the actual inner safe value, not the wrapper object.
                $sce.valueOf(val),
              );
              scope.$watch(htmlWatch, () => {
                // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
                cramp(htmlGetter(scope));
              });
            } else {
              cramp(htmlGetter(scope));
            }
          } else {
            // text mode
            if (dynamic) {
              attrs.$observe('text', (newText) => {
                cramp(newText);
              });
            } else {
              cramp(attrs.text);
            }
          }
        },
      };
    },
  ]);
})();
